
import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, Box, Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faXmark,
    faCheckCircle,
    faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";

const DialogModal = ({
    type,
    title,
    message,
    open,
    handleClose,
}) => {
    const isSuccess = type === "success";

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            className="success_error_modal"
        >
            <Box className="glocy_modal_box">

                {/* Close Button */}
                <button
                    type="button"
                    className="glocy_modal_close"
                    onClick={handleClose}
                    aria-label="Close"
                >
                    <FontAwesomeIcon icon={faXmark} />
                </button>


                {/* Content */}
                <div className="glocy_modal_container">

                    <div className='modal_container'>

                        <h1 id="modal-title">
                            {title}
                        </h1>

                        <p id="modal-description" style={{
                            background: '#f2f2f2',
                            padding: '5px 8px',
                            borderRadius: '10px'
                        }}>
                            {message}
                        </p>

                        <h1 id="modal-title">
                            SMS privacy and message information
                        </h1>


                        <p id="modal-description">
                            Figgers Law offers separate consultation and matter-related messages and informational and promotional messages. You may choose either, both, or neither. SMS consent is optional. Message frequency varies, and recurring messages may be sent. Message and data rates may apply.

                            Reply STOP, CANCEL, END, QUIT, UNSUBSCRIBE, REVOKE, or OPT OUT to stop future messages. Reply HELP for assistance. Consent to promotional messages is not a condition of requesting a consultation, hiring the Firm, receiving legal services, or purchasing any property, goods, or services.

                            No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. SMS opt-in data and consent are excluded from other disclosure categories and will not be shared except with telecommunications and messaging providers solely to deliver messages, persons authorized by the subscriber, or when required by law. Those recipients may not use the information for their own marketing or promotional purposes.
                        </p>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                            <Link to='/privacy-policy'
                                target="_blank"
                                rel="noopener noreferrer"
                                className="glocy_modal_btn success_btn"
                                variant="contained">
                                Read the Privacy Policy
                            </Link>

                            <Link to='/terms-and-conditions'
                                target="_blank"
                                rel="noopener noreferrer"
                                className="glocy_modal_btn success_btn"
                                variant="contained">Read the Terms and Conditions</Link>

                        </div>

                    </div>


                    {/* <Button
                        className={
                            isSuccess
                                ? "glocy_modal_btn success_btn"
                                : "glocy_modal_btn error_btn"
                        }
                        variant="contained"
                        onClick={handleClose}
                    >
                        Continue
                    </Button> */}

                </div>
            </Box>
        </Modal>
    );
};

export default DialogModal;